import React from "react";
import { LuActivity as Activity } from "react-icons/lu";
import { SectionHeader } from "../section-header";
import { StatCard } from "../stat-card";
import { StatsByCategoryMap } from "../../types";
import { calcPercentage } from "../../utils/stats.util";

type Props = {
  stats: StatsByCategoryMap["SESSIONS"];
  expiry: number;
};

export const SessionsStatsSection: React.FC<Props> = ({ stats, expiry }) => {
  return (
    <div className="mb-8">
      <SectionHeader icon={Activity} title="Sessions Statistics" updateInfo={expiry} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard icon={Activity} title="Total Sessions" value={stats.TOTAL_SESSIONS.count} />
        <StatCard
          icon={Activity}
          title="Sessions (Last Month)"
          value={stats.LAST_MONTH_SESSIONS.count}
          change={`${calcPercentage(stats.TOTAL_SESSIONS.count, stats.LAST_MONTH_SESSIONS.count)}% of Total`}
        />
        <StatCard
          icon={Activity}
          title="Completed Sessions"
          value={stats.COMPLETED_SESSIONS.count}
          change={`${calcPercentage(stats.TOTAL_SESSIONS.count, stats.COMPLETED_SESSIONS.count)}% of Total`}
          changeColor="text-blue-600"
        />
        <StatCard
          icon={Activity}
          title="Completed Booked Sessions"
          value={stats.COMPLETED_BOOKED_SESSIONS.count}
          change={`${calcPercentage(stats.TOTAL_SESSIONS.count, stats.COMPLETED_BOOKED_SESSIONS.count)}% of Total`}
          changeColor="text-blue-600"
        />
        <StatCard
          icon={Activity}
          title="Completed Direct Sessions"
          value={stats.COMPLETED_DIRECT_SESSIONS.count}
          change={`${calcPercentage(stats.TOTAL_SESSIONS.count, stats.COMPLETED_DIRECT_SESSIONS.count)}% of Total`}
          changeColor="text-blue-600"
        />
        <StatCard
          icon={Activity}
          title="Completed Lounge Sessions"
          value={stats.COMPLETED_LOUNGE_SESSIONS.count}
          change={`${calcPercentage(stats.TOTAL_SESSIONS.count, stats.COMPLETED_LOUNGE_SESSIONS.count)}% of Total`}
          changeColor="text-blue-600"
        />

        <StatCard
          icon={Activity}
          title="Missed Booked Sessions"
          value={stats.MISSED_BOOKED_SESSIONS.count}
          change={`${calcPercentage(stats.TOTAL_SESSIONS.count, stats.MISSED_BOOKED_SESSIONS.count)}% of Total`}
          changeColor="text-red-600"
        />
        <StatCard
          icon={Activity}
          title="Missed Direct Sessions"
          value={stats.MISSED_DIRECT_SESSIONS.count}
          change={`${calcPercentage(stats.TOTAL_SESSIONS.count, stats.MISSED_DIRECT_SESSIONS.count)}% of Total`}
          changeColor="text-red-600"
        />
      </div>
    </div>
  );
};
